// extracted by mini-css-extract-plugin
export default {"advertCard":"c-a_iX","advertCardNum":"c-a_iY"};